<template>
	<div>
		<v-text-field
			v-if="tipoComprobacion == 1"
			v-model="respuesta"
			label="Respuesta"
			placeholder="Valor númerico"
			type="number"
			hide-spin-buttons
			clearable
			:disabled="disabled"
			:error-messages="errorRespuesta"
			@focus="errorRespuesta = null"
		></v-text-field>
		<template v-else-if="tipoComprobacion == 2">
			<v-radio-group
				v-model="respuesta"
				row
				hide-details
				class="mt-0 custom-radio-group"
				:disabled="disabled"
				:error-messages="errorRespuesta"
				@change="errorRespuesta = null"
			>
				<v-radio
					v-for="(opcion, idxOpc) in opciones"
					:key="`opcion - ${idxOpc}`"
					class="mb-2"
                    :disabled="disabled"
					:label="opcion"
					:value="opcion"
				></v-radio>
			</v-radio-group>
            <v-slide-y-transition>
                <p
                    v-if="errorRespuesta"
                    class="mb-0 error--text text-center"
                >
                    {{ errorRespuesta }}
                </p>
            </v-slide-y-transition>
		</template>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			type: String,
			default: null,
		},
		tipoComprobacion: {
			type: Number,
			required: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		errorMessage: {
			type: String,
			default: null,
		},
        opciones: {
            type: Array,
            default: () => []
        }
	},
    computed: {
        errorRespuesta: {
            get(){
                return this.errorMessage;
            },
            set(newValue){
                this.$emit('update:errorMessage',newValue);
            }
        },
        respuesta: {
            get(){
                return this.value;
            },
            set(newValue){
                this.$emit('input',newValue);
            }
        }
    }
};
</script>
<style scoped>
.custom-radio-group >>> .v-messages {
	text-align: center;
}

.custom-radio-group >>> .v-label {
	color: rgba(0,0,0,.87);
    font-size: 20px;
}

.custom-radio-group >>> .v-input--radio-group__input {
	justify-content: center;
}

.custom-radio-group >>> .v-input--selection-controls__input {
    height: 34px;
    width: 34px;
}

.custom-radio-group >>> .v-icon {
    font-size: 34px;
}

.custom-radio-group >>> .v-input--selection-controls__ripple {
    left: -8px;
    top: calc(50% - 25px);
    height: 36px;
    width: 36px;
}
</style>